<script lang="ts" setup>
  import type { components } from '../../../shared/api/schema.gen';
  import { LogoText } from '../../../shared/ui/logo-text';
  import { MobileViewLayout } from '../../../shared/ui/mobile-view-layout';
  import { Stack } from '../../../shared/ui/stack';

  type Feedback = components['schemas']['Feedback'];

  defineProps<{ feedback: Feedback[] }>();

  const formatDate = (iso: string): string =>
    new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
</script>

<template>
  <MobileViewLayout space="m">
    <LogoText class="title" text="Feedback" />

    <Stack as="ul" class="feedback-list" space="m" tabindex="0">
      <li v-for="item in feedback" :key="item.id" class="feedback-item">
        <p class="feedback-message">{{ item.feedback }}</p>
        <p class="feedback-meta">
          <span class="nickname">{{ item.nickname }}</span> - <span>{{ formatDate(item.createdAt) }}</span>
        </p>
      </li>
    </Stack>
  </MobileViewLayout>
</template>

<style scoped>
  .title {
    font-size: var(--font-size-2xl);
  }

  .feedback-list {
    flex: 1 1 auto;
    list-style: none;
    margin: 0;
    max-width: var(--control-max-width);
    min-height: 0;
    overflow-y: auto;
    padding: 0;
    scrollbar-color: var(--color-primary) var(--color-scrollbar-track);
    scrollbar-width: thin;
    width: 100%;
  }

  .feedback-item {
    background: var(--color-surface);
    border-radius: var(--radius-card);
    box-shadow: 0 4px 12px var(--color-shadow);
    flex-shrink: 0;
    padding: var(--card-padding);
  }

  .feedback-message {
    line-height: 1.4;
    margin: 0 0 0.5rem;
    overflow-wrap: anywhere;
    white-space: pre-line;
  }

  .feedback-meta {
    color: var(--color-text-muted);
    font-size: var(--font-size-xs);
    margin: 0;
  }

  .nickname {
    font-family: var(--font-nickname);
  }
</style>
